import ApplicationRecord from './ApplicationRecord';
import * as ChroniqueSections from './ChroniqueSection';
import ImageRecord from './ImageRecord';

export default class Chronique extends ApplicationRecord({
  Title: '',
  Text: '',
  SummaryText: '',
  SummaryTextOriginal: '',
  _embedded: {},
}) {
  /**
   * @return {ImageRecord} Image always shown
   */
  cover() {
    return this._getOne('CoverImg', ImageRecord);
  }

  /**
   * Get a list of chroniques, dependant of the type
   * @return {List<? extends AbstractChronique>}
   */
  sections() {
    return this._getMany(
      'ChroniqueSections',
      chroniqueDoc =>
        new ChroniqueSections[`ChroniqueSection${chroniqueDoc.ChroniqueType}`](
          chroniqueDoc
        )
    );
  }
}



// WEBPACK FOOTER //
// ./src/models/Chronique.js